import React, { useState } from "react";
import ClassNames from "classnames";
import styles from "./styles.module.css";
import { TabPage } from "../../../components";
import FlaggedRequestTable from "./FlaggedRequestTable";

const FlaggedRequest = () => {
  const [currentTab, setCurrentTab] = useState(1);

  return (
    <TabPage pageTitle="Digitizer/ Flagged Requests">
      <div className="grid w-full h-full">
        <div className={styles.tab_container}>
          <div
            className={ClassNames(
              styles.tab_item,
              currentTab === 1 && styles.active
            )}
            onClick={() => setCurrentTab(1)}
          >
            Transcripts
          </div>
          <div
            className={ClassNames(
              styles.tab_item,
              currentTab === 2 && styles.active
            )}
            onClick={() => setCurrentTab(2)}
          >
            Proficiency
          </div>
          <div
            className={ClassNames(
              styles.tab_item,
              currentTab === 3 && styles.active
            )}
            onClick={() => setCurrentTab(3)}
          >
            Post Graduate
          </div>
          <div
            className={ClassNames(
              styles.tab_item,
              currentTab === 4 && styles.active
            )}
            onClick={() => setCurrentTab(4)}
          >
            NCE
          </div>
        </div>
        {currentTab === 1 && <FlaggedRequestTable requestType={1} />}
        {currentTab === 2 && <FlaggedRequestTable requestType={2}/>}
        {currentTab === 3 && <FlaggedRequestTable requestType={3}/>}
        {currentTab === 4 && <FlaggedRequestTable requestType={4}/>}
      </div>
    </TabPage>
  );
};
export default FlaggedRequest;
